import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setIsDark as setIsDarkAction } from '@store/slices/chartSlice';

import AppContext from './AppContext';

const DARK_KEY = 'app-theme';

export const AppProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [isDark, setIsDark] = useState(() => {
    return localStorage.getItem(DARK_KEY) === 'dark';
  });

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
    document.body.classList.toggle('dark', isDark);
    localStorage.setItem(DARK_KEY, isDark ? 'dark' : 'light');
    dispatch(setIsDarkAction(isDark));
  }, [isDark]);

  const toggleDark = useCallback(() => setIsDark(prev => !prev), []);

  return (
    <AppContext.Provider value={{ config: { isDark }, toggleDark }}>
      {children}
    </AppContext.Provider>
  );
};